import { render, staticRenderFns } from "./Holder.vue?vue&type=template&id=e3cf0f4a&scoped=true"
import script from "./Holder.vue?vue&type=script&lang=js"
export * from "./Holder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3cf0f4a",
  null
  
)

export default component.exports